import AccountCircle from "@mui/icons-material/AccountCircle";
import { AppBar, Menu, MenuItem, Toolbar } from "@mui/material";
import { withStyles } from "@mui/styles";
import * as React from "react";
import cookie from "react-cookies";
import { withRouter } from "react-router-dom";

class AppBarWrappedMain extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            currentTarget: null,
            isMenuOpen: false,
            isEnvMenuOpen: false,
        };
    }

    handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ currentTarget: event.currentTarget as any, isMenuOpen: true });
    }

    handleEnvMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ currentTarget: event.currentTarget as any, isEnvMenuOpen: true });
    }

    handleMenuClose = () => {
        this.setState({ currentTarget: null, isMenuOpen: false, isEnvMenuOpen: false });
    }

    logout = () => {
        cookie.remove("brl-target-app");
        cookie.remove("brl-session-token");
        cookie.remove("active-env");

        // Reset app state
        this.props.resetAppState();
    }

    settings = () => {
        this.props.history.push("/user/settings");
    }

    setActiveEnv = (activeEnv) => {
        this.setState({ currentTarget: null, isMenuOpen: false, isEnvMenuOpen: false });
        this.props.setActiveEnv(activeEnv);
    }

    renderMenu() {
        return <Menu
            anchorEl={this.state.currentTarget}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={this.state.isMenuOpen}
            onClose={this.handleMenuClose}
        >
            <MenuItem onClick={this.settings}>Settings</MenuItem>
            <MenuItem onClick={this.logout}>Logout</MenuItem>
        </Menu>;
    }

    render() {
        const { classes } = this.props;

        return <div>
            <AppBar
                position="fixed"
                className={classes.appBar}
            >
                <Toolbar>
                    <div style={{ flexGrow: 1 }}/>
                    <div style={{display: "flex"}}>
                        <div onClick={this.handleProfileMenuOpen} className="appBar-user" style={{ marginRight: 10 }}>
                            <AccountCircle/>
                            <span>
                                {this.props.activeUser.fullName}
                            </span>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>

            {this.renderMenu()}
        </div>;
    }
}

const styles: any = theme => ({
    appBar: {
        width: `calc(100% - ${264}px)`,
        zIndex: theme.zIndex.drawer + 1,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxShadow: "none!important"
    },
});

export const AppBarWrapped = withStyles(styles)(withRouter(AppBarWrappedMain));
